/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';
import type { AppWaldenViewDetailModel } from 'walden-fast/routes/app/walden-view/detail';
import type { FilterValues } from 'walden-fast/types/filters';
import type UserService from 'walden-fast/services/user';
import config from 'walden-fast/config/environment';

export interface WaldenViewDetailPageSignature {
  Args: {
    applyFilters: (filters: FilterValues) => void;
    canUseFilters: boolean;
    currentFilters: FilterValues | null;
    model: AppWaldenViewDetailModel;
  };
  Element: null;
}

export default class WaldenViewDetailPageComponent extends Component<WaldenViewDetailPageSignature> {
  @tracked _showDisclaimer: boolean | undefined;
  @service('user') declare userService: UserService;

  get showDisclaimer(): boolean {
    // List of reports that have a disclaimer
    const reportsWithDisclaimer = ['Order2Cash'];

    const isOrder2Cash = reportsWithDisclaimer.includes(
      this.args?.model?.report?.internalCode || '',
    );

    if (!isOrder2Cash) {
      return false;
    }

    const excludedClients =
      config.waldenViewDisclaimerExcludedClients
        ?.split(',')
        ?.map((client: string) => client.trim()) || [];
    const user = this.userService.user;
    if (user?.account) {
      const clientNameMaster =
        user.account?.externalIdentifiers?.powerBI?.clientNameMaster;

      const isClientExcluded =
        clientNameMaster && excludedClients.includes(clientNameMaster);

      if (isClientExcluded) {
        return false;
      }
    }

    // Check if user has previously hidden the disclaimer
    const hasHiddenDisclaimer =
      window.localStorage.getItem('hideWaldenViewDisclaimer') === 'true';

    return this._showDisclaimer === undefined
      ? !hasHiddenDisclaimer
      : this._showDisclaimer;
  }

  set showDisclaimer(value: boolean) {
    this._showDisclaimer = value;
  }

  @action
  onHideDisclaimer() {
    this.showDisclaimer = false;
    window.localStorage.setItem('hideWaldenViewDisclaimer', 'true');
  }
}
